/** Horizontal progress bar 0–10, filled with threshold-keyed color. */

/** Returns a hex fill color for a 0–10 score using the design thresholds. */
export function scoreFill(value: number): string {
	if (value >= 7) return "var(--color-success)";
	if (value >= 6) return "var(--color-primary)";
	if (value >= 5) return "var(--color-warning)";
	return "var(--color-danger)";
}

/** Returns a Tailwind text-color class for a 0–10 score. */
export function scoreToneClass(value: number): string {
	if (value >= 7) return "text-semantic-success";
	if (value >= 6) return "text-ink";
	if (value >= 5) return "text-warning";
	return "text-danger";
}

interface ScoreBarProps {
	value: number;
	max?: number;
	height?: number;
}

export function ScoreBar({ value, max = 10, height = 4 }: ScoreBarProps) {
	const pct = Math.max(0, Math.min(1, value / max));
	return (
		<div className="w-full overflow-hidden rounded-full bg-surface-3" style={{ height }}>
			<div
				className="h-full rounded-full"
				style={{ width: `${pct * 100}%`, background: scoreFill(value) }}
			/>
		</div>
	);
}
